// SEO Configuration for all routes
export const seoConfig = {
  // Default/English homepage
  '/': {
    title: 'PickStar AI - AI Sports Betting Predictions | MLB, NFL, NBA Analysis',
    description: 'Get AI-powered sports betting predictions with 85% accuracy. Real-time odds analysis, injury reports, and expert picks for MLB, NFL, NBA, UFC. Try free today.',
    keywords: 'AI sports betting, sports betting predictions, MLB betting AI, NFL predictions AI, NBA betting analysis, sports odds AI, betting assistant, AI picks',
    ogTitle: 'PickStar AI - Your Personal AI Sports Betting Assistant',
    ogDescription: 'Transform your sports betting with AI. Real-time analysis, smart predictions, and data-driven insights for MLB, NFL, NBA, and more.',
    ogImage: '/og-image-home.png',
    twitterCard: 'summary_large_image',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "PickStar AI",
      "applicationCategory": "Sports Betting Analysis Tool",
      "operatingSystem": "Web",
      "url": "https://pickstarai.com",
      "description": "AI-powered sports betting predictions and analysis platform",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD",
        "availability": "https://schema.org/InStock"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "ratingCount": "2847"
      },
      "potentialAction": {
        "@type": "UseAction",
        "target": "https://pickstarai.com/chat"
      }
    }
  },
  
  // Portuguese/Brazilian homepage - OPTIMIZED WITH HIGH-VOLUME KEYWORDS
  '/pt-br': {
    title: 'Robô de Apostas Esportivas Grátis com IA | Palpites Brasileirão',
    description: 'Inteligência artificial apostas futebol com 85% precisão. Palpites IA Brasileirão, previsões apostas com IA, análise Libertadores. App apostas grátis!',
    keywords: 'inteligência artificial apostas futebol, palpites IA Brasileirão, robô de apostas esportivas grátis, previsões apostas com IA, app apostas inteligência artificial, IA apostas Libertadores, palpites Copa do Brasil IA, análise IA Campeonato Paulista, previsões IA Serie B, apostas IA futebol brasileiro, robô de palpites certeiros, IA para fazer a fezinha, dicas quentes apostas IA, zebras do Brasileirão IA, análise de cantos e escanteios IA, multiplas, apostas multiplas IA, multiplas Brasileirão, robô multiplas futebol',
    lang: 'pt-BR',
    ogTitle: 'Robô de Palpites Certeiros - IA para Apostas Brasileirão Grátis',
    ogDescription: 'Robô de apostas esportivas grátis com IA. Palpites certeiros Brasileirão, Copa do Brasil, Libertadores. Análise de cantos e escanteios. Faz a fezinha com inteligência!',
    ogImage: '/og-image-ptbr.png',
    ogLocale: 'pt_BR',
    twitterCard: 'summary_large_image',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "@language": "pt-BR",
      "name": "Robô de Apostas PickStar AI - Palpites Brasileirão",
      "alternativeName": "Robô de Palpites Certeiros com IA",
      "applicationCategory": "Robô de Apostas Esportivas Grátis",
      "operatingSystem": "Web",
      "url": "https://pickstarai.com/pt-br",
      "description": "Robô de apostas esportivas grátis com inteligência artificial. Palpites IA Brasileirão, Copa do Brasil, Libertadores. Análise de cantos, escanteios e zebras. App apostas para fazer a fezinha com IA.",
      "keywords": "robô apostas, palpites certeiros, IA Brasileirão, zebras futebol, análise cantos escanteios",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "BRL",
        "availability": "https://schema.org/InStock"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "ratingCount": "1523"
      },
      "potentialAction": {
        "@type": "UseAction",
        "target": "https://pickstarai.com/pt-br"
      }
    }
  },
  
  // Chat page (most important for conversions)
  '/chat': {
    title: 'AI Sports Betting Chat - Get Instant Predictions | PickStar AI',
    description: 'Chat with our AI for instant sports betting predictions. MLB, NFL, NBA odds analysis, injury reports, and winning picks. 24/7 availability. Start free.',
    keywords: 'sports betting chat, AI betting assistant, live odds analysis, sports predictions chat, betting AI bot, instant betting picks',
    ogTitle: 'Chat with AI for Winning Sports Picks - PickStar AI',
    ogDescription: 'Get instant AI predictions for your bets. Real-time odds, expert analysis, and data-driven picks.',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "ChatApplication",
      "name": "PickStar AI Chat",
      "description": "AI-powered sports betting chat assistant",
      "url": "https://pickstarai.com/chat",
      "provider": {
        "@type": "Organization",
        "name": "PickStar Labs LLC"
      }
    }
  },
  
  // Sports Hub
  '/sports-hub': {
    title: 'Live Sports Data & AI Analysis - All Sports | PickStar AI',
    description: 'Real-time sports data with AI analysis. MLB, NFL, NBA, UFC, Soccer stats, odds movements, and predictive insights all in one dashboard.',
    keywords: 'sports data dashboard, live sports stats, AI sports analysis, betting dashboard, odds tracker, sports analytics platform',
    ogTitle: 'Sports Hub - Live Data & AI Analysis | PickStar AI',
    ogDescription: 'Your command center for sports betting. Live data, AI insights, and odds tracking for all major sports.'
  },

  // About Us page
  '/about-us': {
    title: 'About PickStar AI - AI Sports Betting Intelligence Platform',
    description: 'Learn about PickStar AI, the leading AI-powered sports betting research platform. Our mission is to democratize sports betting intelligence with advanced machine learning.',
    keywords: 'about pickstar ai, sports betting AI company, AI betting platform, sports analytics company, betting intelligence platform',
    ogTitle: 'About PickStar AI - Revolutionizing Sports Betting with AI',
    ogDescription: 'Discover how PickStar AI uses advanced machine learning to provide winning sports betting predictions with 85%+ accuracy.',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "About PickStar AI",
      "description": "AI-powered sports betting intelligence platform",
      "url": "https://pickstarai.com/about-us"
    }
  },

  // FAQ page
  '/faq': {
    title: 'FAQ - Frequently Asked Questions | PickStar AI',
    description: 'Get answers to common questions about PickStar AI. Learn how our AI sports betting predictions work, pricing, accuracy rates, and supported sports.',
    keywords: 'pickstar ai faq, sports betting ai questions, how does pickstar work, ai betting help, sports prediction faq',
    ogTitle: 'Frequently Asked Questions - PickStar AI',
    ogDescription: 'Everything you need to know about using PickStar AI for smarter sports betting. Accuracy, pricing, features, and more.',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "name": "PickStar AI FAQ",
      "url": "https://pickstarai.com/faq"
    }
  },
  
  // Baseball specific
  '/mlb': {
    title: 'MLB Betting AI - Predictions, Props, Live Odds | PickStar AI',
    description: 'AI-powered MLB betting predictions with 87% accuracy. Player props, game totals, run lines, and live odds analysis. Updated every inning.',
    keywords: 'MLB betting AI, baseball predictions, MLB props, baseball betting picks, MLB odds today, AI baseball analysis',
    ogTitle: 'MLB Betting AI - Smart Predictions & Live Analysis',
    ogDescription: 'Dominate MLB betting with AI. Real-time predictions, player props, and data-driven picks.'
  },
  
  // Football/NFL specific
  '/nfl': {
    title: 'NFL Betting AI - Game Predictions & Props | PickStar AI',
    description: 'NFL betting predictions powered by AI. Spread picks, player props, over/under analysis with 85% win rate. Updated for every game.',
    keywords: 'NFL betting AI, football predictions, NFL props, football betting picks, NFL odds AI, NFL spread picks',
    ogTitle: 'NFL Betting AI - Expert Predictions & Analysis',
    ogDescription: 'Win more NFL bets with AI analysis. Spreads, totals, props, and live betting insights.'
  },
  
  // Brazilian Football Specific Pages
  '/pt-br/brasileirao': {
    title: 'Palpites Brasileirão Série A e B com IA | Robô Certeiro Grátis',
    description: 'Robô de palpites certeiros Brasileirão. IA analisa todos jogos Serie A e B. Zebras, análise de cantos e escanteios. Dicas quentes apostas grátis!',
    keywords: 'palpites Brasileirão IA, robô Serie A, zebras Brasileirão, análise cantos Serie B, palpites certeiros futebol brasileiro',
    lang: 'pt-BR',
    ogTitle: 'Brasileirão - Robô de Palpites com IA | 87% Acerto',
    ogDescription: 'Palpites certeiros para todos os jogos do Brasileirão. IA analisa zebras, cantos e escanteios.'
  },
  
  '/pt-br/libertadores': {
    title: 'IA Apostas Libertadores | Palpites Copa Libertadores Grátis',
    description: 'Robô apostas Libertadores com inteligência artificial. Análise completa de todos os jogos, fase de grupos até a final. Palpites certeiros grátis!',
    keywords: 'IA apostas Libertadores, palpites Copa Libertadores, robô apostas Libertadores, análise IA Libertadores',
    lang: 'pt-BR',
    ogTitle: 'Libertadores - Palpites com IA | Análise Completa',
    ogDescription: 'IA especializada em Copa Libertadores. Palpites para todos os jogos com análise profunda.'
  },
  
  '/pt-br/copa-do-brasil': {
    title: 'Palpites Copa do Brasil IA | Robô Análise Mata-Mata',
    description: 'Robô especializado Copa do Brasil. IA analisa confrontos mata-mata, zebras históricas, estatísticas casa/fora. Fazer a fezinha com inteligência!',
    keywords: 'palpites Copa do Brasil IA, robô mata-mata, zebras Copa do Brasil, análise IA Copa Brasil',
    lang: 'pt-BR',
    ogTitle: 'Copa do Brasil - Robô de Apostas IA | Zebras e Palpites',
    ogDescription: 'Especialista em mata-mata. IA prevê zebras e resultados Copa do Brasil.'
  },
  
  '/pt-br/estaduais': {
    title: 'Análise IA Campeonatos Estaduais | Paulistão, Cariocão, Mineirão',
    description: 'Robô apostas estaduais. Palpites IA Paulistão, Cariocão, Gauchão, Mineirão. Análise regional especializada. Dicas quentes apostas grátis!',
    keywords: 'análise IA Campeonato Paulista, palpites Cariocão IA, robô Gauchão, IA Mineirão, apostas estaduais',
    lang: 'pt-BR',
    ogTitle: 'Estaduais - Palpites IA Paulistão, Cariocão | Robô Regional',
    ogDescription: 'IA especializada em campeonatos estaduais. Análise regional para melhores palpites.'
  },
  
  '/pt-br/cantos-escanteios': {
    title: 'Análise de Cantos e Escanteios IA | Robô Especializado Grátis',
    description: 'Robô especialista em cantos e escanteios. IA analisa médias, confrontos diretos, estilo de jogo. Mercado de cantos asiáticos. 100% grátis!',
    keywords: 'análise de cantos e escanteios IA, robô cantos, apostas escanteios, IA mercado asiático cantos',
    lang: 'pt-BR',
    ogTitle: 'Cantos e Escanteios - Robô Especializado com IA',
    ogDescription: 'IA focada em análise de cantos. Previsões precisas para mercado de escanteios.'
  },
  
  '/pt-br/fazer-fezinha': {
    title: 'IA para Fazer a Fezinha | Robô Apostas Pequenas Grátis',
    description: 'Robô perfeito para fazer a fezinha com segurança. IA analisa melhores odds para apostas pequenas. Dicas certeiras, gestão de banca. Grátis!',
    keywords: 'IA para fazer a fezinha, robô apostas pequenas, palpites fezinha, dicas apostas baixas IA',
    lang: 'pt-BR',
    ogTitle: 'Fazer a Fezinha com IA - Robô para Apostas Pequenas',
    ogDescription: 'IA especializada em apostas pequenas. Fazer a fezinha com inteligência e segurança.'
  },
  
  // Pricing page
  '/pricing': {
    title: 'Pricing - Start Free, Upgrade Anytime | PickStar AI',
    description: 'Start with free AI sports betting predictions. Premium plans with unlimited picks, advanced analytics, and priority support. No credit card required.',
    keywords: 'sports betting AI pricing, betting assistant cost, AI picks subscription, sports analysis pricing',
    ogTitle: 'Simple, Transparent Pricing - PickStar AI',
    ogDescription: 'Start free. Get unlimited AI predictions, advanced analytics, and more with our premium plans.'
  },
  
  // Resource Pages (English)
  '/guide': {
    title: 'Sports Betting Guide - Learn AI-Powered Betting | PickStar AI',
    description: 'Complete guide to sports betting with AI. Learn betting basics, strategies, bankroll management, and how to use AI predictions for smarter bets.',
    keywords: 'sports betting guide, AI betting guide, betting strategies, bankroll management, sports betting basics, how to bet',
    ogTitle: 'Complete Sports Betting Guide with AI - PickStar AI',
    ogDescription: 'Master sports betting fundamentals with AI-powered insights. Learn strategies, bankroll management, and smart betting practices.'
  },
  
  '/technology': {
    title: 'AI Technology - How Our Sports Betting AI Works | PickStar AI',
    description: 'Discover the cutting-edge AI technology behind PickStar\'s sports betting predictions. Machine learning, neural networks, and real-time data analysis explained.',
    keywords: 'sports betting AI technology, machine learning betting, neural networks sports, AI predictions technology, betting algorithms',
    ogTitle: 'Advanced AI Technology for Sports Betting - PickStar AI',
    ogDescription: 'Learn how our AI achieves 85% accuracy using neural networks, big data, and machine learning for sports predictions.'
  },
  
  '/responsible-gaming': {
    title: 'Responsible Gaming - Bet Safely with AI Guidance | PickStar AI',
    description: 'Learn about responsible sports betting practices. Get help with problem gambling, set limits, and use AI to make informed betting decisions.',
    keywords: 'responsible gambling, betting limits, problem gambling help, safe betting, gambling addiction resources',
    ogTitle: 'Responsible Gaming & Safe Betting Practices - PickStar AI',
    ogDescription: 'Your wellbeing comes first. Learn responsible betting practices and find help resources for problem gambling.'
  },
  
  // Resource Pages (Portuguese)
  '/pt-br/guia': {
    title: 'Guia de Apostas Esportivas com IA - Aprenda a Apostar | PickStar AI',
    description: 'Guia completo de apostas esportivas com IA. Aprenda básicos, estratégias, gestão de banca e como usar previsões de IA para apostas mais inteligentes.',
    keywords: 'guia apostas esportivas, guia apostas IA, estratégias apostas, gestão de banca, como apostar, apostas para iniciantes',
    lang: 'pt-BR',
    ogTitle: 'Guia Completo de Apostas Esportivas com IA - PickStar AI',
    ogDescription: 'Domine apostas esportivas com insights de IA. Aprenda estratégias, gestão de banca e práticas inteligentes.',
    ogLocale: 'pt_BR'
  },
  
  '/pt-br/tecnologia': {
    title: 'Tecnologia IA - Como Nossa IA de Apostas Funciona | PickStar AI',
    description: 'Descubra a tecnologia de IA por trás das previsões de apostas da PickStar. Machine learning, redes neurais e análise de dados em tempo real explicados.',
    keywords: 'tecnologia IA apostas, machine learning apostas, redes neurais esportes, tecnologia previsões IA, algoritmos apostas',
    lang: 'pt-BR',
    ogTitle: 'Tecnologia Avançada de IA para Apostas Esportivas - PickStar AI',
    ogDescription: 'Saiba como nossa IA alcança 85% de precisão usando redes neurais, big data e machine learning para previsões esportivas.',
    ogLocale: 'pt_BR'
  },
  
  '/pt-br/jogo-responsavel': {
    title: 'Jogo Responsável - Aposte com Segurança e IA | PickStar AI',
    description: 'Aprenda sobre práticas responsáveis de apostas esportivas. Obtenha ajuda com vício em jogos, estabeleça limites e use IA para decisões informadas.',
    keywords: 'jogo responsável, limites apostas, ajuda vício jogos, apostas seguras, recursos vício apostas, jogadores anônimos',
    lang: 'pt-BR',
    ogTitle: 'Jogo Responsável e Práticas Seguras de Apostas - PickStar AI',
    ogDescription: 'Seu bem-estar vem primeiro. Aprenda práticas responsáveis de apostas e encontre recursos de ajuda para problemas com jogos.',
    ogLocale: 'pt_BR'
  },

  // NEW SEO PAGES - Quick Wins for Generic AI + Betting Keywords

  // English Pillar Page: AI Sports Betting Picks
  '/ai-sports-betting-picks': {
    title: 'AI Sports Betting Picks | Free AI Predictions for NFL, NBA, MLB, Soccer',
    description: 'Get professional AI sports betting picks with 65%+ accuracy. Our machine learning models analyze NFL, NBA, MLB, Soccer for the smartest betting predictions. Free AI picks daily.',
    keywords: 'ai sports betting picks, ai picks, ai betting predictions, sports predictions ai, ai betting tips, machine learning sports betting, nfl ai picks, nba ai picks, mlb ai picks, soccer ai predictions',
    ogTitle: 'AI Sports Betting Picks - Free Predictions with 65%+ Win Rate',
    ogDescription: 'Professional AI sports picks for NFL, NBA, MLB, Soccer. Data-driven predictions updated 24/7. Start winning more bets today.',
    ogImage: '/og-home-logo.png',
    twitterCard: 'summary_large_image',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": "AI Sports Betting Picks - Smarter Predictions",
      "description": "Professional-grade AI sports betting picks for NFL, NBA, MLB, Soccer with 65%+ accuracy.",
      "url": "https://pickstarai.com/ai-sports-betting-picks"
    }
  },

  // Portuguese Pillar Page: Palpites da IA
  '/palpites-ia': {
    title: 'Palpites da IA Grátis | Robô de Apostas Esportivas com Inteligência Artificial',
    description: 'Palpites certeiros da IA para Brasileirão, Libertadores, Copa do Brasil. Robô de apostas grátis com 67%+ de precisão. App de inteligência artificial para futebol e apostas esportivas.',
    keywords: 'palpites ia, palpites da ia, robô de palpites de futebol grátis, inteligência artificial apostas futebol, app apostas inteligência artificial, robô de apostas esportivas grátis, palpites certeiros, ia futebol',
    lang: 'pt-BR',
    ogTitle: 'Palpites da IA - Robô de Apostas Grátis | 67% de Precisão',
    ogDescription: 'Robô de palpites certeiros com IA. Brasileirão, Libertadores, Copa do Brasil. 100% grátis!',
    ogImage: '/og-home-logo.png',
    ogLocale: 'pt_BR',
    twitterCard: 'summary_large_image',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": "Palpites da IA: Robô de Apostas Esportivas Grátis",
      "description": "Palpites certeiros de IA com 67%+ precisão para futebol brasileiro.",
      "url": "https://pickstarai.com/palpites-ia"
    }
  },

  // Comparison Article: AI vs Human Picks
  '/ai-vs-human-picks': {
    title: 'AI vs Human Sports Picks: Which Wins More Often? | Betting Accuracy Comparison',
    description: 'AI sports picks vs human experts: See the data. AI averages 65%+ win rate vs 53% for humans. Compare accuracy, speed, and consistency in NFL, NBA, MLB, Soccer betting.',
    keywords: 'ai picks vs human, ai betting accuracy, human vs ai sports picks, ai sports betting comparison, betting ai vs experts, sports prediction ai, human handicapper vs ai',
    ogTitle: 'AI vs Human Sports Picks - Data-Driven Comparison',
    ogDescription: 'The data is clear: AI beats human experts. See head-to-head win rates across NFL, NBA, MLB, Soccer.',
    ogImage: '/og-home-logo.png',
    twitterCard: 'summary_large_image',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": "AI vs Human Sports Picks: Which Wins More Often?",
      "description": "Data-driven comparison showing AI outperforms human experts in sports betting.",
      "url": "https://pickstarai.com/ai-vs-human-picks"
    }
  },

  // Portuguese How-To: Como Usar IA para Apostas
  '/como-usar-ia-apostas-esportivas': {
    title: 'Como Usar IA para Apostas Esportivas | Guia Completo PickStar AI',
    description: 'Aprenda a usar inteligência artificial para apostas esportivas. Guia completo do PickStar AI com exemplos práticos, dicas profissionais e estratégias vencedoras.',
    keywords: 'como usar ia para apostas, inteligência artificial apostas esportivas, ia apostas futebol, como apostar com ia, pickstar ai tutorial, apostas com inteligência artificial',
    lang: 'pt-BR',
    ogTitle: 'Como Usar IA para Apostas - Tutorial Completo PickStar AI',
    ogDescription: 'Guia passo a passo: aprenda a usar IA para fazer apostas mais inteligentes e lucrativas.',
    ogImage: '/og-home-logo.png',
    ogLocale: 'pt_BR',
    twitterCard: 'summary_large_image',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "HowTo",
      "name": "Como Usar IA para Apostas Esportivas",
      "description": "Guia completo para usar inteligência artificial nas suas apostas esportivas.",
      "url": "https://pickstarai.com/como-usar-ia-apostas-esportivas"
    }
  },

  // Event Hook Page: Libertadores AI Picks 2025
  '/libertadores-ai-picks-2025': {
    title: 'Palpites da IA para Libertadores 2025 | Sites de Apostas Copa Libertadores',
    description: 'Palpites certeiros da IA para a Copa Libertadores 2025. Análise completa dos favoritos, zebras e melhores estratégias de apostas com PickStar AI.',
    keywords: 'libertadores 2025, palpites libertadores, site de apostas libertadores, sites de apostas copa libertadores, palpites ia libertadores, favoritos libertadores 2025, apostas libertadores',
    lang: 'pt-BR',
    ogTitle: 'Libertadores 2025 - Palpites da IA | Análise Completa',
    ogDescription: 'Análise completa da IA para a Libertadores 2025. Favoritos, zebras e estratégias para cada fase.',
    ogImage: '/og-home-logo.png',
    ogLocale: 'pt_BR',
    twitterCard: 'summary_large_image',
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": "Palpites da IA para a Libertadores 2025",
      "description": "Análise completa com IA para Copa Libertadores 2025.",
      "url": "https://pickstarai.com/libertadores-ai-picks-2025"
    }
  }
};

// Helper function to get SEO data for current route
export const getSEOData = (pathname) => {
  // Check for exact match first
  if (seoConfig[pathname]) {
    return seoConfig[pathname];
  }
  
  // Check for pattern matches (e.g., /nfl/* should use /nfl config)
  const basePath = '/' + pathname.split('/')[1];
  if (seoConfig[basePath]) {
    return seoConfig[basePath];
  }
  
  // Default to homepage SEO
  return seoConfig['/'];
};

// Generate canonical URL
export const getCanonicalUrl = (pathname) => {
  const baseUrl = 'https://pickstarai.com';
  // Remove trailing slashes and query params for canonical
  const cleanPath = pathname.replace(/\/$/, '').split('?')[0];
  return baseUrl + cleanPath;
};

// Generate hreflang tags for international SEO
export const getHreflangTags = (currentPath) => {
  const tags = [];
  
  if (currentPath === '/pt-br') {
    tags.push({ rel: 'alternate', hreflang: 'pt-BR', href: 'https://pickstarai.com/pt-br' });
    tags.push({ rel: 'alternate', hreflang: 'en', href: 'https://pickstarai.com' });
    tags.push({ rel: 'alternate', hreflang: 'x-default', href: 'https://pickstarai.com' });
  } else {
    tags.push({ rel: 'alternate', hreflang: 'en', href: 'https://pickstarai.com' });
    tags.push({ rel: 'alternate', hreflang: 'pt-BR', href: 'https://pickstarai.com/pt-br' });
    tags.push({ rel: 'alternate', hreflang: 'x-default', href: 'https://pickstarai.com' });
  }
  
  return tags;
};